import React, { FC } from 'react';
import { Icon, Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';
import { useTranslation } from 'react-i18next';

const useQmrDashboardStyle = createUseStyles({
    banner: {
        padding: 20,
        display: 'flex',
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: colors.blueOne,
        width: '100%',
        boxSizing: 'border-box',
    },
    bannerContentWrapper: {
        display: 'flex',
        width: '100%',
    },
    bannerContent: {
        flexGrow: 1,
        width: 'calc(100% - 180px)',
    },
    importedSiebelIcon: {
        marginRight: 15,
    },
});

const EmergencyGuideBanner: FC<{}> = () => {
    const classes = useQmrDashboardStyle();
    const { t } = useTranslation();

    return (
        <div className={classes.banner}>
            <div className={classes.bannerContentWrapper}>
                <div className={classes.importedSiebelIcon}>
                    <Icon name="info-solid" color="white" />
                </div>
                <div className={classes.bannerContent}>
                    <Typography
                        variant="default"
                        color="white"
                        style={{
                            marginBottom: 16,
                            fontFamily: 'Roboto',
                            fontWeight: 600,
                            fontSize: 15,
                            letterSpacing: 0,
                        }}
                    >
                        {t('This document only applies to hybrid and electric vehicles (EVs).')}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default EmergencyGuideBanner;
